import { render, staticRenderFns } from "./activity_detail.vue?vue&type=template&id=a4ad2b6c&scoped=true"
import script from "./activity_detail.vue?vue&type=script&lang=js"
export * from "./activity_detail.vue?vue&type=script&lang=js"
import style0 from "./activity_detail.vue?vue&type=style&index=0&id=a4ad2b6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad2b6c",
  null
  
)

export default component.exports